module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgaWQ9Ik1hc2siIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iI0Q5RDlEOSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/mask-circle.svg
// module id = 1263
// module chunks = 4 5